export const SERVICE_KEY = 'data-hub-pg';
export const DATA_HUB_SVC_SERVICE_KEY = SERVICE_KEY;
//# sourceMappingURL=constants.js.map